import { StyledConceptRaceFinalFeedback } from './ConceptRaceFinalFeedback.styled';
import { useContext, useEffect } from 'react';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import Sprite from '@/shared/GameComponents/GameObjects/Sprite/Sprite';
import { GameStageContext } from '@/shared/GameComponents/GameStageContext/GameStageContext';
import { AudioAutoPlayerContext } from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayerContext';
import { GameAssetsContext } from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';

export default function ConceptRaceFinalFeedback({}) {
  const stage = useContext(GameStageContext);
  const audioPlayer = useContext(AudioAutoPlayerContext);
  const { state: assets } = useContext(GameAssetsContext);

  const conceptSize = 15;
  const conceptHeight = (stage.state.responsiveLength * conceptSize) / 100;
  const game = useContext(GameLoopContext);

  const dedupedAnswers = game.state.answersLog.reduce((acc, answer) => {
    const existingAnswer = acc.find(
      (accAnswer) => accAnswer.conceptId == answer.conceptId
    );
    if (existingAnswer) {
      existingAnswer.answerId = answer.answerId;
      existingAnswer.correct = answer.correct;
      existingAnswer.timedOut = answer.timedOut;
    } else {
      acc = [...acc, answer];
    }
    return acc;
  }, []);

  const totalConcepts = game.state.gameConf.animations.length;
  const rightAnswersCount = dedupedAnswers.filter(
    (answer) => answer.conceptId == answer.answerId
  ).length;
  const failedAnswers = dedupedAnswers.filter(
    (answer) => answer.conceptId != answer.answerId
  );
  const allCorrect = rightAnswersCount == totalConcepts;

  useEffect(() => {
    audioPlayer.actions.activate();
  }, []);

  return (
    <StyledConceptRaceFinalFeedback
      conceptHeight={conceptHeight}
      stage={stage.state}
    >
      {allCorrect ? (
        <>
          <div className="title success">Congratulations!</div>
          <div className="subtitle">
            You've successfully completed the game and got all answers right
          </div>
        </>
      ) : (
        <>
          <div className="title">You've completed the game</div>
          <div className="subtitle">
            You've answered {rightAnswersCount} out of {totalConcepts} concepts
            correctly
          </div>
          <div className="corrections">
            <div className="correction-desc">
              Below you can review the correct answers for the concepts you
              didn't get right
            </div>
            <div className="corrections-list">
              {failedAnswers.map((concept) => (
                <div className="concept-correction" key={concept.conceptId}>
                  <div
                    className="concept-animation"
                    onClick={async () => {
                      await audioPlayer.actions.play(
                        assets.sounds[concept.conceptId].audio
                      );
                    }}
                  >
                    <Sprite
                      spriteId={getSpriteId(
                        game.state.concepts,
                        concept.conceptId
                      )}
                      animId="normal"
                      transform={{
                        x: 0,
                        y: 0,
                        width: conceptSize,
                        height: conceptSize,
                      }}
                    />
                  </div>
                  <div
                    className="concept-correction-name"
                    onClick={async () => {
                      await audioPlayer.actions.play(
                        assets.sounds[concept.conceptId].audio
                      );
                    }}
                  >
                    {
                      game.state.concepts.find((c) => c.id == concept.conceptId)
                        .text
                    }
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </StyledConceptRaceFinalFeedback>
  );
}

function getSpriteId(concepts, conceptId) {
  const concept = concepts.find((c) => c.id == conceptId);
  return concept.atlasId || concept.id;
}
